import React, { useState } from "react";
import Popup from "reactjs-popup";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import "./ExportCsvConfirmPopup.scss";

const ExportCsvConfirmPopup = ({ open, onClose, onConfirm }) => {
  const [isAccepted, setIsAccepted] = useState(false);

  const handleConfirm = () => {
    if (!isAccepted) return;
    onConfirm();
    handleClose();
  };

  const handleClose = () => {
    setIsAccepted(false);
    onClose();
  };

  return (
    <Popup
      open={open}
      onClose={handleClose}
      modal
      closeOnDocumentClick={false}
      contentStyle={{
        padding: 0,
        borderRadius: 10,
        border: "none",
        boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
        width: "100%",
        maxWidth: 460,
      }}
      overlayStyle={{
        zIndex: 999999,
        background: "rgba(0,0,0,0.45)",
      }}
    >
      <div className="ecp-popup">
        <div className="ecp-popup__header">
          <span className="ecp-popup__icon">
            <WarningRoundedIcon fontSize="small" />
          </span>
          <h2 className="ecp-popup__title">Confirm CSV Export</h2>
        </div>

        <p className="ecp-popup__description ">
          This file contains sensitive IT system information. By downloading, you acknowledge the accountability for its secure handling and compliance with data policies.
        </p>

        <label className="ecp-popup__checkbox">
          <input
            type="checkbox"
            className="ecp-popup__checkbox-input"
            checked={isAccepted}
            onChange={(e) => setIsAccepted(e.target.checked)}
          />
          <span className="ecp-popup__checkbox-label">
            I acknowledge and accept the risk.
          </span>
        </label>

        <div className="ecp-popup__actions">
          <button className="ecp-popup__btn ecp-popup__btn--cancel" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="ecp-popup__btn ecp-popup__btn--confirm"
            onClick={handleConfirm}
            disabled={!isAccepted}
          >
            Download
          </button>
        </div>
      </div>
    </Popup>
  );
};

export default ExportCsvConfirmPopup;